import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/Files.scss';
import * as _ from 'lodash';
import autobind from 'autobind-decorator';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import {
  __,
  dateFrom,
  mapStateToProps,
  setTableParams,
} from '../../core/utils';
import CloseMediumIcon from '../../assets/images/close-middle-15x15.svg';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import {
  deleteHrFile,
  uploadHrFiles,
} from '../../redux/actions/table/my_company_members';
import { listCompanyFolders } from '../../redux/actions/table/company_folders';
import classNames from 'classnames';
import FilePreview from '../../components/FilePreview';
import ReactDropzone from 'react-dropzone';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import { Form, getFormValues, reduxForm, Field } from 'redux-form';
import Select from '../../components/Select';
import Input from '../../components/Input';
import EditIcon from '../../assets/images/edit-16x16.svg';

@reduxForm({
  form: 'my_company_members.files',
  enableReinitialize: true,
})
@mapStateToProps((state, props) => ({
  store: state.table.products,
  values: getFormValues('my_company_members.files')(state),
  flyout: state.table.my_company_members.flyout,
}))
class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: [],
      files: [],
      active_category: null,
      category_errors: null,
      possible_folders: [],
    };
  }

  // @autobind
  // _handleSubmit(formData) {
  //   const { id, user_id } = this.props.data;

  //   formData = {
  //     ...formData,
  //   };

  //   return validateForm(
  //     updateCompanyMember(id, _.omit(formData, ['id'])).then(() => {
  //       this.props.readAction(id);

  //       setNotification(__('my-company-members.properties.saved'));
  //     })
  //   );
  // }

  @autobind
  _toggleCollapseCategory(folder_id) {
    this.setState({
      expanded: _.xor(this.state.expanded, [folder_id]),
    });
  }

  componentDidMount() {
    const { files, images } = this.props.flyout;

    this.setState({
      //expanded: _.map([...files, ...images], (file) => file.category),
      expanded: _.map([...files], (file) => file.folder_id),
    });

    // window.addEventListener('paste', this._handlePaste);

    listCompanyFolders().then(({ response }) => {
      this.setState({ possible_folders: response.data });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('paste', this._handlePaste);
  }

  @autobind
  _handlePaste(event) {
    const files = event.clipboardData.files;

    this.setState({
      files: [
        ...this.state.files,
        ..._.map(files, (file) => {
          return {
            file: Object.assign(file, {
              stream_url: URL.createObjectURL(file),
              ext: file.name.split('.').pop(),
            }),
            category: '',
          };
        }),
      ],
    });

    this.props.change('files', files);
  }

  @autobind
  _uploadFiles(category, files) {
    setNotification(__('my-company-members.files.please-wait-files-uploaded'));

    //    const userFlyoutId = this.props.data?.details?.id;
    // const filesWithUserId = this.state.files.map((f) => ({
    // const filesWithUserId = Object.values(this.state.files).forEach((f) => ({
    //   ...f,
    //   user_id: userFlyoutId,
    //   file: f.file,
    // }));

    uploadHrFiles(this.state.files)
      // uploadHrFiles(filesWithUserId)
      .then(() => {
        this.props.readAction().then(({ response }) => {
          const { files } = response.data;

          this.setState({
            // expanded: _.map([...files, ...images], (file) => file.category),
            expanded: _.map(files, (file) => file.folder_id),
            files: [],
            category_errors: null,
            active_category: null,
          });
        });
      })
      .catch((error) => {
        this.setState({
          category_errors: _.map(Object.keys(error.response.errors), (key) =>
            _.toNumber(_.first(key.match(/\d+/)))
          ),
        });

        setNotification({
          text: __(
            'my-company-members.files.your-files-not-uploaded.duble-check-file-formats-sizes'
          ),
          type: 'warning',
        });
      });
  }

  @autobind
  _downloadFile({ download_url }) {
    setNotification(__('my-company-members.files.download.continue'));

    window.open(download_url, '_blank');
  }

  @autobind
  _removeFile(attachment_id) {
    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'my-company-members.files.are-you-sure-to-remove-this-file'
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () =>
            deleteHrFile(attachment_id).then(() => {
              hideAlertbox();

              this.props.readAction();

              setNotification(
                __('my-company-members.files.selected-file-deleted')
              );
            }),
        },
      ],
    });
  }

  @autobind
  _handleDrop(acceptedFiles, rejectedFiles) {
    this.setState({ drag: false });

    if (!_.isEmpty(acceptedFiles)) {
      if (_.size(rejectedFiles) > 1) {
        setNotification({
          text: __('my-company-members.files.upload.bulk-not-allowed'),
          type: 'warning',
        });
      } else if (!_.isEmpty(rejectedFiles)) {
        setNotification({
          text: __('my-company-members.files.upload.incorrect.format'),
          type: 'warning',
        });
      } else if (
        _.find(acceptedFiles, (file) => {
          return file.size >= 312857600;
        })
      ) {
        setNotification({
          text: __('my-company-members.files.upload.upload-limit'),
          type: 'warning',
        });
      } else {
        this.setState({
          files: [
            ...this.state.files,
            ..._.map(acceptedFiles, (file) => {
              return {
                file: Object.assign(file, {
                  stream_url: URL.createObjectURL(file),
                  ext: file.name.split('.').pop(),
                }),
                folder_id: '',
                description: '',
                user_id: this.props.data?.details?.id,
                name: file.name.replace(/\.[^/.]+$/, ''),
              };
            }),
          ],
        });

        this.props.change('files', acceptedFiles);
      }
    }
  }

  render() {
    const { data, collapsed, flyout, readOnly } = this.props;
    const { possible_folders, expanded } = this.state;

    const folders = possible_folders?.map((folder) => ({
      label: folder.name,
      value: folder.id,
    }));

    const { files, category_errors, active_category } = this.state;

    const lightbox_files = _.map(
      _.filter(files, (row) =>
        _.includes(['jpg', 'jpeg', 'png'], _.toLower(row.file.ext))
      ),
      (row) => ({
        id: row.file.id,
        attachment_version_id: row.file.attachment_version_id,
        stream_url: row.file.stream_url,
        download_url: row.file.download_url,
        title: [row.file.name, row.file.ext].join('.'),
      })
    );

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        {/* Files list */}
        {_.map(folders, (category) => {
          const category_files = _.sortBy(
            _.filter(flyout.files, ['folder_id', category.value]),
            ['order']
          );

          const lightbox_images = _.map(
            _.filter(category_files, (file) =>
              _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(file.ext))
            ),
            (file) => ({
              id: file.file_id,
              attachment_version_id: file.attachment_version_id,
              stream_url: file.stream_url,
              title: [file.file_name, file.ext].join('.'),
              download_url: file.download_url,
              ext: file.ext,
              width: file?.width,
              height: file?.height,
            })
          );

          return (
            <>
              {!_.isEmpty(category_files) && (
                <div className={styles.category} key={category.value}>
                  <div
                    className={styles.title}
                    onClick={() => this._toggleCollapseCategory(category.value)}
                  >
                    <ArrowDownMiddleIcon
                      className={classNames(
                        styles.collapse,
                        !_.includes(expanded, category.value) &&
                          styles.collapsed
                      )}
                    />
                    {category.label}{' '}
                    {!_.isEmpty(category_files) &&
                      '(' + _.size(category_files) + ')'}
                  </div>
                  {_.includes(expanded, category.value) &&
                    !_.isEmpty(category_files) && (
                      <div className={styles.files}>
                        <div className={styles.fileHeader}>
                          <div className={styles.name}>
                            <strong>Name</strong>
                          </div>
                          <div className={styles.description}>
                            <strong>Notes</strong>
                          </div>
                          <div className={styles.date}>
                            <strong>Date</strong>
                          </div>
                        </div>
                        {_.map(category_files, (file, i) => {
                          return (
                            <div className={styles.file} key={i}>
                              <div className={styles.fileWrapper}>
                                <FilePreview
                                  onDownloadFile={this._downloadFile}
                                  row={{
                                    ...file,
                                    name: file.file_name,
                                    id: file.file_id,
                                  }}
                                  lightbox_images={lightbox_images}
                                />
                              </div>

                              <div className={styles.infoWrapper}>
                                <div className={styles.description}>
                                  {/* <strong>
                                    {__(
                                      'my_company_members.flyout.description'
                                    )}
                                  </strong> */}

                                  <span>
                                    {_.get(file, 'description') ?? __('n/a')}
                                  </span>
                                </div>

                                <div className={styles.date}>
                                  {/* <strong>Date</strong> */}

                                  {/* <span>12.12.12</span> */}
                                  <span>{dateFrom(file?.created_at)}</span>
                                </div>

                                {!readOnly && (
                                  <div className={styles.icons}>
                                    <div className={styles.edit}>
                                      <EditIcon
                                        onClick={() =>
                                          setTableParams('my_company_members', {
                                            edit_my_company_member_file_folder_wizard: true,
                                            folder_id: category.value,
                                            description: file.description,
                                            file_id: file.file_id,
                                            file_name: file.file_name,
                                          })
                                        }
                                      />
                                    </div>
                                    <div className={styles.remove}>
                                      <CloseMediumIcon
                                        onClick={() =>
                                          this._removeFile(file.file_id)
                                        }
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                </div>
              )}
            </>
          );
        })}

        {/* Dropzone - upload files */}
        {!readOnly && (
          <ReactDropzone
            className={classNames(
              styles.dropzone,
              _.get(this.state, 'drag') && styles.drag
            )}
            onDrop={this._handleDrop}
            onDragOver={() => this.setState({ drag: true })}
            onDragLeave={() => this.setState({ drag: false })}
            multiple={true}
          >
            <UploadIcon />
            <span className={styles.dropTitle}>
              {__('dropzone.title.drop-your-file-here')}
            </span>
            <span className={styles.dropSubtitle}>
              {__('dropzone.title.or-select')}
            </span>
          </ReactDropzone>
        )}

        {/* Clickboard files */}
        {!_.isEmpty(files) && (
          <Form className={styles.clickboardFiles} onSubmit={this.handleSubmit}>
            {_.map(files, (row, i) => {
              const key = _.toNumber(i);
              return (
                <div className={styles.fileRow} key={key}>
                  <div className={styles.left}>
                    <FilePreview
                      onDownloadFile={this._downloadFile}
                      row={row.file}
                      lightbox_images={lightbox_files}
                    />
                  </div>

                  <div className={styles.right}>
                    <div className={styles.description}>
                      <Field
                        //disabled={disabled}
                        name={`files[${i}].description`}
                        component={Input}
                        placeholder={__(
                          'my_company_members.flyout.file-add-description'
                        )}
                        label={__('my_company_members.flyout.description')}
                        onChange={(e, value) => {
                          this.setState({
                            files: {
                              ...this.state.files,
                              [key]: {
                                ...this.state.files[key],
                                description: value,
                                user_id: this.props.data?.details?.id,
                              },
                            },

                            category_errors: _.filter(
                              category_errors,
                              (error) => error != key
                            ),
                          });
                        }}
                      />
                    </div>
                    {/* <div className={styles.f1}></div> */}
                    <div className={styles.select}>
                      <Select
                        disabled={readOnly}
                        placeholder={__(
                          'my_company_members.flyout.select-file-folder'
                        )}
                        label='folder'
                        input={{
                          value:
                            // this.state.files && this.state.files[i]?.category
                            //   ? this.state.files[i].category
                            this.state.files && this.state.files[i]?.folder_id
                              ? this.state.files[i].folder_id
                              : '',
                          onChange: (value) => {
                            this.setState({
                              files: {
                                ...this.state.files,
                                [key]: {
                                  ...this.state.files[key],
                                  // category: value,s
                                  folder_id: value,
                                  // name: _.find(folders, ['value', value])
                                  //   ?.label,
                                },
                              },

                              category_errors: _.filter(
                                category_errors,
                                (error) => error != key
                              ),
                            });
                          },
                          onBlur: () =>
                            this.setState({
                              active_category: { [key]: false },
                            }),
                          onFocus: () =>
                            this.setState({ active_category: { [key]: true } }),
                        }}
                        meta={{
                          active: active_category && active_category[key],
                          error: _.includes(category_errors, key),
                          touched: _.includes(category_errors, key),
                        }}
                        options={folders}
                        top={28}
                        noSort
                        searchable
                      />
                    </div>
                    {!readOnly && (
                      <div className={styles.icons}>
                        <DeleteIcon
                          onClick={() => {
                            this.setState(
                              {
                                files: _.filter(files, (file) => file != row),
                              },
                              () => {
                                this.props.change('files', this.state.files);
                              }
                            );
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
            {!readOnly && (
              <div className={styles.addRow}>
                <button onClick={this._uploadFiles} type='button'>
                  {__('my_company_members.flyout.add-files')}
                </button>
              </div>
            )}
          </Form>
        )}
      </div>
    );
  }
}

export default Files;
